import { useMediaQuery, useTheme } from '@mui/material';

/**
 * One breakpoint for the whole app: below `md` (900px) is "mobile".
 *
 * A single shared answer rather than per-component media queries, because the
 * layout switches as a unit — the drawer becomes temporary, the license matrix
 * becomes a card list, and tables become cards, all at the same width. Letting
 * those disagree produces a drawer overlaying a table that still thinks it has
 * room.
 */
export function useIsMobile(): boolean {
  const theme = useTheme();
  // `noSsr` because this app is client-rendered: without it the first render
  // assumes desktop and the layout visibly snaps on a phone.
  return useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
}
